import { get, includes, filter, find, orderBy, reject, values } from 'lodash';
import { DateTime } from 'luxon';
import PageKey from '../../lib/page-data/key';

export const isLoadingStream = (state) => get(state, 'activityStream.loading');

export const hasAttemptedLoad = (state, clubId, filters) => {
  const key = new PageKey(clubId, 'news', filters);
  return includes(get(state, `activityStream.loaded`), key.toString());
};

export const getMessages = (state, filters) => {
  let messages = get(state, 'activityStream.messages');
  if (filters.month) {
    const monthStart = DateTime.fromFormat(`${filters.month}-01`, 'yyyy-MM-dd');
    const monthEnd = DateTime.fromFormat(`${filters.month}-01`, 'yyyy-MM-dd').endOf('month');
    messages = filter(messages, (message) => {
      const published = DateTime.fromISO(message.published);
      return published >= monthStart && published <= monthEnd;
    });
  }

  if (filters.teamId) {
    messages = filter(messages, { team_id: filters.teamId });
  }

  if (filters.category) {
    messages = filter(messages, { type: filters.category });
  }

  return values(orderBy(messages, ['published'], ['desc']));
};

export const getMessagesWithoutCurrentItem = (state, itemId) => {
  const messages = getMessages(state, {});
  const filteredMessages = reject(messages, { id: `news-${itemId}` });
  return filteredMessages.slice(0, 8);
};

export const getMessage = (state, messageId) => {
  const messages = getMessages(state, {});
  return find(messages, { id: messageId });
};
export const getRelatedContent = (state, messageId) =>
  get(state, `activityStream.relatedContent[${messageId}]`, []);

export const isLoadingRelatedContent = (state) =>
  get(state, 'activityStream.relatedContentLoading');
export const hasLoadedRelatedContent = (state, messageId) =>
  includes(get(state, 'activityStream.loadedRelatedContent'), messageId);
